import {Injectable, EventEmitter} from '@angular/core';
import {UrlConfig} from 'config/urlConfig';
import {NetworkService} from 'services/network.service';
import {Constants} from 'config/constants';
import {EmissionRequestParams} from 'models/emissionRequestParams';
import {DashboardService} from 'services/dashboard.service';

const INDIVIDUAL_CALCULATOR = Constants.calculators.individual;
const VEHICLE_CATEGORY = Constants.categories.individual.vehicle;

@Injectable()
export class EmissionService {
    private emission = {
        categories: {/*vehicle, travel, energy, transit, ...*/},
        total: 0,
        inTrees: 0,
        inDollars: 0,
        inDollarsPerMonth: 0
    };

    public emission$: EventEmitter<any>;

    constructor(private networkService: NetworkService,
                private dashboardService: DashboardService
    ) {
        this.emission$ = new EventEmitter();
    }

    private getTotalEmissionPrice() {
        let totalEmission = 0;
        for (let property in this.emission.categories) {
            if (this.emission.categories.hasOwnProperty(property)) {
                totalEmission += this.emission.categories[property].emission;
            }
        }

        this.getTotalPrice(totalEmission).subscribe(
            response => {
                let emission = response[0];
                this.emission.total = totalEmission;
                this.emission.inTrees = emission.emissionTrees;
                this.emission.inDollars = emission.DollarAmt;
                this.emission.inDollarsPerMonth = emission.DollarAmtMonthly;
                this.dashboardService.onDataChange({emission: this.emission});
            }
        );
    }

    public getTotalPrice(emission: number) {
        let currentCalculatorName = this.dashboardService.getCurrentCalculatorName(),
            prop = {'emmissions': emission, 'profile': currentCalculatorName};
        return this.networkService.post(UrlConfig.getUrl('getPrice'), prop);
    }

    private setTotalEmission() {
        let categoryLength = Object.keys(this.emission.categories).length;
        this.emission.total = 0;
        this.emission.inTrees = 0;
        this.emission.inDollars = 0;
        this.emission.inDollarsPerMonth = 0;

        if (categoryLength === 1) {
            for (let property in this.emission.categories) {
                if (this.emission.categories.hasOwnProperty(property)) {
                    this.emission.total += this.emission.categories[property].emission;
                    this.emission.inTrees += this.emission.categories[property].inTrees;
                    this.emission.inDollars += this.emission.categories[property].inDollars;
                    this.emission.inDollarsPerMonth += this.emission.categories[property].inDollarsPerMonth;
                }
            }
            this.dashboardService.onDataChange({emission: this.emission});
        } else {
            this.getTotalEmissionPrice();
        }
    }

    public clearSavedData(): void {
        this.emission = {
            categories: {},
            total: 0,
            inTrees: 0,
            inDollars: 0,
            inDollarsPerMonth: 0
        };
    }

    getEmissionValue(params, calculatorName = INDIVIDUAL_CALCULATOR, categoryName = VEHICLE_CATEGORY) {
        let currentCalculatorName = this.dashboardService.getCurrentCalculatorName();
        return this.networkService.post(
            UrlConfig.getUrl('getEmissionValue'),
            new EmissionRequestParams(params, calculatorName, categoryName, currentCalculatorName)
        );
    }

    setEmission(data: {category, emission}) {
        this.emission.categories[data.category] = {
            emission: data.emission.emission,
            inTrees: data.emission.emissionTrees,
            inDollars: data.emission.DollarAmt,
            inDollarsPerMonth: data.emission.DollarAmtMonthly
        };
        this.setTotalEmission();
    }

    getEmission() {
        return this.emission;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/emission.service.ts